import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageOverflow = () => {
    const location = useLocation();

    const autoOverflowPaths = useMemo(
        () => [
            '/privacy-policy',
            '/terms-of-use',
            '/eula',
            '/',
            '/dashboard',
            '/contact',
            '/pricing',
            '/about',
            '/features',
            '/creativity',
            '/brand-analytics',
            '/teamwork',
            '/version-control',
            '/approval-process',
            '/onboarding',
        ],
        [],
    );

    useEffect(() => {
        document.body.style.overflow = autoOverflowPaths.includes(location.pathname)
            ? 'auto'
            : 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, [location.pathname, autoOverflowPaths]);
};
